import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { LogService } from './services/log.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected title = 'PaymentClient';
  private logService = inject(LogService);

  constructor() {
    this.logService.LogMessage("Environment: " + environment.environment);
  }
}
